import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=527d60b8&"
import script from "./FilesList.vue?vue&type=script&lang=js&"
export * from "./FilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports